<template>
    
    <div v-if="showShareOptions" class="social-icons">
        <a :href="shareLinks.email" target="_blank" title="Email" v-html="icons.email"></a>
        <a :href="shareLinks.facebook" target="_blank" title="Facebook" v-html="icons.facebook"></a>
        <a :href="shareLinks.twitter" target="_blank" title="Twitter" v-html="icons.twitter"></a>
        <a :href="shareLinks.linkedin" target="_blank" title="LinkedIn" v-html="icons.linkedin"></a>
    </div>
    <ion-toolbar class="job-detail-toolbar">
        <ion-buttons slot="start">
            <ion-button class="button_back" data-testid="directions-87" @click="goBack()">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>Job Details</ion-title>
        <ion-buttons slot="end" class="toolbar-end-buttons">
            <ion-button class="button_more" @click="toggleShareOptions" data-testid="share-pharmacy-btn">
                <i class="el-icon-share"></i>
            </ion-button>
            <!-- Social Media Icons -->
        </ion-buttons>
        
        
    </ion-toolbar>
    <div class="main_wrapper ion-padding">

        <div v-if="jobUnavailable && !initialLoading" class="job-unavailable-state">
            <p class="job-unavailable-message">The job ad is not available anymore</p>
            <el-button type="primary" @click="goBack()">Back to home</el-button>
        </div>

        <div class="job-detail-wrapper" v-if="job !== null && initialLoading === false && !jobUnavailable">

            <div class="container">
                <div class="job-detail-header">
                    <div class="image_wrapper" data-testid="directions-64" @click="userInfoModalOpen(job.jobPharmacy)">
                        <el-avatar :size="'small'" shape="square" :src="job.pharmacy.image" v-if="job.pharmacy.image" />
                        <el-avatar :size="'small'" class="avatar-job" shape="square"
                            icon="locumate_icons locumate_icon-user1 locumate_icons-avatar" v-else></el-avatar>
                    </div>
                    <div class="job-detail-header-row">
                        <div class="job-detail-header-row-left">
                            <div class="job-title">{{ job.title }}</div>
                            <div class="job-poster">{{ job.pharmacy.name }}</div>
                        </div>
                        <el-tag class="inverted">
                            Published {{ job.publishedDate }}
                        </el-tag>
                    </div>

                    <div class="preview-section">
                        <div class="preview-section__header">
                            <div class="preview-section__title">
                                Job Details
                            </div>
                        </div>

                        <p v-html="displayedText" class="job-description"></p>
                        <el-button class="text-only"
                            :disabled="$store.getters.isAuthenticated && userRole !== 'pharmacy'"
                             @click="toggleView" v-if="isShowMoreJD">{{ state.isTruncated ? 'View More' : 'View Less' }}</el-button>
                    </div>

                    <div class="separator"></div>
                    <div class="preview-section">
                        <div class="detail-item">
                            <div class="detail-item__icon">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M18.3332 9.99984C18.3332 14.5998 14.5998 18.3332 9.99984 18.3332C5.39984 18.3332 1.6665 14.5998 1.6665 9.99984C1.6665 5.39984 5.39984 1.6665 9.99984 1.6665C14.5998 1.6665 18.3332 5.39984 18.3332 9.99984Z"
                                        stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path
                                        d="M13.0919 12.65L10.5086 11.1083C10.0586 10.8416 9.69189 10.2 9.69189 9.67497V6.2583"
                                        stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>

                            </div>
                            <div class="detail-item__value blur-price">{{ job.type }}</div>
                        </div>
                        <div class="detail-item" v-if="!job.hideSalary">
                            <div class="detail-item__icon">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M7.22656 11.9417C7.22656 13.0167 8.05156 13.8834 9.07656 13.8834H11.1682C12.0599 13.8834 12.7849 13.125 12.7849 12.1917C12.7849 11.175 12.3432 10.8167 11.6849 10.5834L8.32656 9.4167C7.66823 9.18337 7.22656 8.82503 7.22656 7.80837C7.22656 6.87503 7.95156 6.1167 8.84323 6.1167H10.9349C11.9599 6.1167 12.7849 6.98337 12.7849 8.05837"
                                        stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M10 5V15" stroke="rgb(var(--locumate-primary-color-dark))"
                                        stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path
                                        d="M9.99984 18.3332C14.6022 18.3332 18.3332 14.6022 18.3332 9.99984C18.3332 5.39746 14.6022 1.6665 9.99984 1.6665C5.39746 1.6665 1.6665 5.39746 1.6665 9.99984C1.6665 14.6022 5.39746 18.3332 9.99984 18.3332Z"
                                        stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>


                            </div>
                            <div class="detail-item__value">{{ job.payInterval }} Rate: <span class="blur-price">{{
                                    job.payRate }}</span></div>
                        </div>
                        <div class="detail-item">
                            <div class="detail-item__icon">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M9.9999 11.1917C11.4358 11.1917 12.5999 10.0276 12.5999 8.5917C12.5999 7.15576 11.4358 5.9917 9.9999 5.9917C8.56396 5.9917 7.3999 7.15576 7.3999 8.5917C7.3999 10.0276 8.56396 11.1917 9.9999 11.1917Z"
                                        stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5" />
                                    <path
                                        d="M3.01675 7.07484C4.65842 -0.141827 15.3501 -0.133494 16.9834 7.08317C17.9418 11.3165 15.3084 14.8998 13.0001 17.1165C11.3251 18.7332 8.67508 18.7332 6.99175 17.1165C4.69175 14.8998 2.05842 11.3082 3.01675 7.07484Z"
                                        stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5" />
                                </svg>

                            </div>
                            <div class="detail-item__value blur-price">{{ job.category }}</div>
                        </div>
                    </div>

                    <!-- <div class="separator"></div>
                    <div class="preview-section">
                        <div class="preview-section__header">
                            <div class="preview-section__title">
                                Created By
                            </div>
                        </div>
                        <div class="job-poster-box border-box">
                            <div class="image_wrapper" data-testid="directions-64"
                                @click="userInfoModalOpen(job.jobPharmacy)">
                                <el-avatar :size="'small'" shape="square" :src="job.pharmacy.image"
                                    v-if="job.pharmacy.image" />
                                <el-avatar :size="'small'" class="avatar-job" shape="square"
                                    icon="locumate_icons locumate_icon-user1 locumate_icons-avatar" v-else></el-avatar>
                            </div>
                            <div class="job-poster-info">
                                <div class="job-poster-name" @click="userInfoModalOpen(job.jobPharmacy)">
                                    {{ job.pharmacy.name }}
                                </div>
                                <div class="job-poster-address blur-price">
                                    XX-XX-XXXXXXXXXXX, XXXX
                                </div>
                            </div>
                            <svg width="30" height="30" viewBox="0 0 30 30" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M27.5001 16.0749C27.5001 18.9374 26.0251 21.4749 23.7501 23.0749L22.0751 26.7624C21.6876 27.5999 20.5626 27.7624 19.9751 27.0499L18.1251 24.8249C15.8001 24.8249 13.6626 24.0374 12.0376 22.7249L12.7876 21.8374C18.5626 21.3999 23.1251 16.8249 23.1251 11.2499C23.1251 10.2999 22.9876 9.3624 22.7376 8.4624C25.5751 9.9624 27.5001 12.8124 27.5001 16.0749Z"
                                    fill="#1746BB" />
                                <path
                                    d="M20.375 7.5875C18.9125 4.5875 15.65 2.5 11.875 2.5C6.7 2.5 2.5 6.4125 2.5 11.25C2.5 14.1125 3.975 16.65 6.25 18.25L7.925 21.9375C8.3125 22.775 9.4375 22.925 10.025 22.225L10.7125 21.4L11.875 20C17.05 20 21.25 16.0875 21.25 11.25C21.25 9.9375 20.9375 8.7 20.375 7.5875ZM15 12.1875H8.75C8.2375 12.1875 7.8125 11.7625 7.8125 11.25C7.8125 10.7375 8.2375 10.3125 8.75 10.3125H15C15.5125 10.3125 15.9375 10.7375 15.9375 11.25C15.9375 11.7625 15.5125 12.1875 15 12.1875Z"
                                    fill="#1746BB" />
                            </svg>
                        </div>
                    </div> -->

                    <div class="separator" v-if="job.selectedJobPostSkills.length > 0"></div>
                    <div class="preview-section" v-if="job.selectedJobPostSkills.length > 0">
                        <div class="preview-section__header">
                            <div class="preview-section__title">
                                Skills
                            </div>
                        </div>

                        <div class="skill-list-pills">
                            <div v-for="skill in job.selectedJobPostSkills" :key="skill.id">
                                <el-tag class="inverted pill">{{ skill.name }}</el-tag>
                            </div>
                        </div>
                    </div>

                    <div class="separator"></div>
                    <div class="preview-section" v-if="job.pharmacy.site.parentId === 1">
                        <div class="preview-section__header">
                            <div class="preview-section__title">
                                Other Details
                            </div>
                        </div>

                        <div v-if="job.pharmacy.scripts" class="job-scripts">
                            <div class="detail-item" v-for="(item, key) in job.pharmacy.scripts" :key="key">
                                <div class="detail-item__icon">
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.6665 10.1665H12.4998"
                                            stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                            stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M6.6665 13.5H10.3165" stroke="rgb(var(--locumate-primary-color-dark))"
                                            stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path
                                            d="M8.33317 4.99984H11.6665C13.3332 4.99984 13.3332 4.1665 13.3332 3.33317C13.3332 1.6665 12.4998 1.6665 11.6665 1.6665H8.33317C7.49984 1.6665 6.6665 1.6665 6.6665 3.33317C6.6665 4.99984 7.49984 4.99984 8.33317 4.99984Z"
                                            stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                            stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                        <path
                                            d="M13.3333 3.3501C16.1083 3.5001 17.5 4.5251 17.5 8.33343V13.3334C17.5 16.6668 16.6667 18.3334 12.5 18.3334H7.5C3.33333 18.3334 2.5 16.6668 2.5 13.3334V8.33343C2.5 4.53343 3.89167 3.5001 6.66667 3.3501"
                                            stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                            stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>

                                </div>
                                <div class="detail-item__content">
                                    <div class="detail-item__topic">
                                        Average script per day {{ key === 'weekdays' ? '(' + key + ')' : key }}
                                    </div>
                                    <div class="detail-item__value">{{ item }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="detail-item" v-if="job.pharmacy.site.parentId === 1">
                            <div class="detail-item__icon">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M6.66685 18.3333H13.3335C16.6835 18.3333 17.2835 16.9917 17.4585 15.3583L18.0835 8.69167C18.3085 6.65833 17.7252 5 14.1668 5H5.83351C2.27518 5 1.69185 6.65833 1.91685 8.69167L2.54185 15.3583C2.71685 16.9917 3.31685 18.3333 6.66685 18.3333Z"
                                        stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                        stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                    <path
                                        d="M6.6665 4.99984V4.33317C6.6665 2.85817 6.6665 1.6665 9.33317 1.6665H10.6665C13.3332 1.6665 13.3332 2.85817 13.3332 4.33317V4.99984"
                                        stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                        stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                    <path
                                        d="M11.6668 10.8333V11.6667C11.6668 11.675 11.6668 11.675 11.6668 11.6833C11.6668 12.5917 11.6585 13.3333 10.0002 13.3333C8.35016 13.3333 8.3335 12.6 8.3335 11.6917V10.8333C8.3335 10 8.3335 10 9.16683 10H10.8335C11.6668 10 11.6668 10 11.6668 10.8333Z"
                                        stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                        stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M18.0415 9.1665C16.1165 10.5665 13.9165 11.3998 11.6665 11.6832"
                                        stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                        stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M2.18311 9.3916C4.05811 10.6749 6.17477 11.4499 8.33311 11.6916"
                                        stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                        stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>

                            </div>
                            <div class="detail-item__content">
                                <div class="detail-item__topic">
                                    Dispensing Software
                                </div>
                                <div class="detail-item__value">
                                    {{ job.pharmacy.software }}<span v-if="job.pharmacy.software === 'Other'">: {{
                                        job.pharmacy.softwareOther }}</span>
                                </div>
                            </div>
                        </div>
                    </div>



                    <div v-if="job.pharmacy.site.parentId === 1">
                        <div class="separator"></div>
                        <div class="preview-section">
                            <div class="preview-section__header">
                                <div class="preview-section__title">
                                    Services
                                </div>
                            </div>
                            <div class="detail-item" v-for="(item, key) in job.pharmacy.services" :key="key">
                                <div class="detail-item__icon">
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M7.49984 18.3332H12.4998C16.6665 18.3332 18.3332 16.6665 18.3332 12.4998V7.49984C18.3332 3.33317 16.6665 1.6665 12.4998 1.6665H7.49984C3.33317 1.6665 1.6665 3.33317 1.6665 7.49984V12.4998C1.6665 16.6665 3.33317 18.3332 7.49984 18.3332Z"
                                            stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M6.4585 9.99993L8.81683 12.3583L13.5418 7.6416"
                                            stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>

                                </div>
                                <div class="detail-item__value">{{ item }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="apply-btn">
                        <el-button class="submit" type="blue" data-testid="directions-88"
                            :disabled="$store.getters.isAuthenticated && userRole !== 'pharmacy'"
                            @click="handleJobPostApplySubmit">Apply Now</el-button>
                    </div>
                </div>
            </div>


            <div class="bg-overlay"></div>
        </div>
        <div v-else><job-listing-skeleton :skeletonCount="1" /></div>

        <el-drawer title="Select CV" custom-class="bottom_drop_up" v-model="dialogVisible" :append-to-body="true"
            :direction="'btt'" :destroy-on-close="true">

            <div>Login Required</div>

            <el-button class="submit" type="blue" data-testid="directions-91" @click="handleConfirm">
                Apply
            </el-button>
        </el-drawer>

    </div>
</template>

<script>
import {
    useRouter, useRoute
} from "vue-router";
import { onMounted, inject, ref, onBeforeMount, computed, reactive } from 'vue';
import { trackEvent } from '@/helpers/analytics/ga.js';
import { addIcons } from 'ionicons';
import { arrowBackOutline } from 'ionicons/icons';
import { ElMessage, ElMessageBox } from "@/components/Vendor/Element";
addIcons({
    'arrow-back-outline': arrowBackOutline,
});
import { IonToolbar, IonButton, } from '@ionic/vue';
import JobListingSkeleton from "@/components/JobListingSkeleton/JobListingSkeleton.vue";

import { useStore } from "vuex";
import { useHead } from '@unhead/vue';
export default {
    components: {
        IonToolbar,
        IonButton,
        JobListingSkeleton,
    },
    setup() {
        const $router = useRouter();
        const $route = useRoute();
        const setPageClassGlobal = inject('setPageClassGlobal');
        const $filters = inject("$filters");
        const dialogVisible = ref(false);
        const showJobApplicationPopupMessage = ref(false);
        const reminderPopupShown = ref(false);
        const selectedOption = ref(null);
        const $store = useStore();
        const isJobApplied = ref(false);
        const initialLoading = ref(false);
        const jobUnavailable = ref(false);
        const userData = $store.getters.GET_USER_DATA;
        const userRole = userData.role;
        const state = reactive({
            isTruncated: true
        });
        const currentUrl = process.env.VUE_APP_CURRENT_URL;
        const showShareOptions = ref(false)
        const shareText = ref('');
        const job = ref();
        console.log("🚀 ~ setup ~ jobasasassa123123:", job)
        const shareUrl = ref('');

        const toggleView = () => {
            state.isTruncated = !state.isTruncated;
        };

        // const questions = ref({});
        const jobId = computed(() => $route.params.jobId);
        const goBack = () => {

            $router.push({
                name: "job-listing-guest",
            });

        };

        const formData = reactive({
            job_post_id: null,
        });


        // const v$ = useVuelidate(validationRules, formData);

        const getClass = (status) => {
            // Convert the status to lowercase for case-insensitive comparison
            const lowercaseStatus = status.toLowerCase();

            // Return class based on status
            return lowercaseStatus;
        };


        const handleClose = () => {
            dialogVisible.value = false;
        };

        const handleConfirm = () => {
            // Handle confirmation logic
            dialogVisible.value = false;
        };



        const icons = {
            email: `<svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24" fill="none"><path d="M4 7.00005L10.2 11.65C11.2667 12.45 12.7333 12.45 13.8 11.65L20 7" stroke="#00000095" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><rect x="3" y="5" width="18" height="14" rx="2" stroke="#00000095" stroke-width="2" stroke-linecap="round"/></svg>`,
            facebook: `<svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 6C2 3.79086 3.79086 2 6 2H18C20.2091 2 22 3.79086 22 6V18C22 20.2091 20.2091 22 18 22H6C3.79086 22 2 20.2091 2 18V6ZM6 4C4.89543 4 4 4.89543 4 6V18C4 19.1046 4.89543 20 6 20H12V13H11C10.4477 13 10 12.5523 10 12C10 11.4477 10.4477 11 11 11H12V9.5C12 7.567 13.567 6 15.5 6H16.1C16.6523 6 17.1 6.44772 17.1 7C17.1 7.55228 16.6523 8 16.1 8H15.5C14.6716 8 14 8.67157 14 9.5V11H16.1C16.6523 11 17.1 11.4477 17.1 12C17.1 12.5523 16.6523 13 16.1 13H14V20H18C19.1046 20 20 19.1046 20 18V6C20 4.89543 19.1046 4 18 4H6Z" fill="#00000095"/></svg>`,
            twitter: `<svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.7828 3.91825C20.1313 3.83565 20.3743 3.75444 20.5734 3.66915C20.8524 3.54961 21.0837 3.40641 21.4492 3.16524C21.7563 2.96255 22.1499 2.9449 22.4739 3.11928C22.7979 3.29366 23 3.6319 23 3.99986C23 5.08079 22.8653 5.96673 22.5535 6.7464C22.2911 7.40221 21.9225 7.93487 21.4816 8.41968C21.2954 11.7828 20.3219 14.4239 18.8336 16.4248C17.291 18.4987 15.2386 19.8268 13.0751 20.5706C10.9179 21.3121 8.63863 21.4778 6.5967 21.2267C4.56816 20.9773 2.69304 20.3057 1.38605 19.2892C1.02813 19.0108 0.902313 18.5264 1.07951 18.109C1.25671 17.6916 1.69256 17.4457 2.14144 17.5099C3.42741 17.6936 4.6653 17.4012 5.6832 16.9832C5.48282 16.8742 5.29389 16.7562 5.11828 16.6346C4.19075 15.9925 3.4424 15.1208 3.10557 14.4471C2.96618 14.1684 2.96474 13.8405 3.10168 13.5606C3.17232 13.4161 3.27562 13.293 3.40104 13.1991C2.04677 12.0814 1.49999 10.5355 1.49999 9.49986C1.49999 9.19192 1.64187 8.90115 1.88459 8.71165C1.98665 8.63197 2.10175 8.57392 2.22308 8.53896C2.12174 8.24222 2.0431 7.94241 1.98316 7.65216C1.71739 6.3653 1.74098 4.91284 2.02985 3.75733C2.1287 3.36191 2.45764 3.06606 2.86129 3.00952C3.26493 2.95299 3.6625 3.14709 3.86618 3.50014C4.94369 5.36782 6.93116 6.50943 8.78086 7.18568C9.6505 7.50362 10.4559 7.70622 11.0596 7.83078C11.1899 6.61019 11.5307 5.6036 12.0538 4.80411C12.7439 3.74932 13.7064 3.12525 14.74 2.84698C16.5227 2.36708 18.5008 2.91382 19.7828 3.91825ZM10.7484 9.80845C10.0633 9.67087 9.12171 9.43976 8.09412 9.06408C6.7369 8.56789 5.16088 7.79418 3.84072 6.59571C3.86435 6.81625 3.89789 7.03492 3.94183 7.24766C4.16308 8.31899 4.5742 8.91899 4.94721 9.10549C5.40342 9.3336 5.61484 9.8685 5.43787 10.3469C5.19827 10.9946 4.56809 11.0477 3.99551 10.9046C4.45603 11.595 5.28377 12.2834 6.66439 12.5135C7.14057 12.5929 7.49208 13.0011 7.49986 13.4838C7.50765 13.9665 7.16949 14.3858 6.69611 14.4805L5.82565 14.6546C5.95881 14.7703 6.103 14.8838 6.2567 14.9902C6.95362 15.4727 7.65336 15.6808 8.25746 15.5298C8.70991 15.4167 9.18047 15.6313 9.39163 16.0472C9.60278 16.463 9.49846 16.9696 9.14018 17.2681C8.49626 17.8041 7.74425 18.2342 6.99057 18.5911C6.63675 18.7587 6.24134 18.9241 5.8119 19.0697C6.14218 19.1402 6.48586 19.198 6.84078 19.2417C8.61136 19.4594 10.5821 19.3126 12.4249 18.6792C14.2614 18.0479 15.9589 16.9385 17.2289 15.2312C18.497 13.5262 19.382 11.1667 19.5007 7.96291C19.51 7.71067 19.6144 7.47129 19.7929 7.29281C20.2425 6.84316 20.6141 6.32777 20.7969 5.7143C20.477 5.81403 20.1168 5.90035 19.6878 5.98237C19.3623 6.04459 19.0272 5.94156 18.7929 5.70727C18.0284 4.94274 16.5164 4.43998 15.2599 4.77822C14.6686 4.93741 14.1311 5.28203 13.7274 5.89906C13.3153 6.52904 13 7.51045 13 8.9999C13 9.28288 12.8801 9.5526 12.6701 9.74221C12.1721 10.1917 11.334 9.92603 10.7484 9.80845Z" fill="#00000095"/></svg>`, // ← insert full Twitter SVG
            linkedin: `<svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24" fill="none"><path d="M6.5 8C7.32843 8 8 7.32843 8 6.5C8 5.67157 7.32843 5 6.5 5C5.67157 5 5 5.67157 5 6.5C5 7.32843 5.67157 8 6.5 8Z" fill="#0F0F0F"/><path d="M5 10C5 9.44772 5.44772 9 6 9H7C7.55228 9 8 9.44771 8 10V18C8 18.5523 7.55228 19 7 19H6C5.44772 19 5 18.5523 5 18V10Z" fill="#0F0F0F"/><path d="M11 19H12C12.5523 19 13 18.5523 13 18V13.5C13 12 16 11 16 13V18.0004C16 18.5527 16.4477 19 17 19H18C18.5523 19 19 18.5523 19 18V12C19 10 17.5 9 15.5 9C13.5 9 13 10.5 13 10.5V10C13 9.44771 12.5523 9 12 9H11C10.4477 9 10 9.44772 10 10V18C10 18.5523 10.4477 19 11 19Z" fill="#0F0F0F"/><path fill-rule="evenodd" clip-rule="evenodd" d="M20 1C21.6569 1 23 2.34315 23 4V20C23 21.6569 21.6569 23 20 23H4C2.34315 23 1 21.6569 1 20V4C1 2.34315 2.34315 1 4 1H20ZM20 3C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20Z" fill="#00000095"/></svg>`, // ← insert full LinkedIn SVG
        }





        const handleJobPostApplySubmit = async () => {

            reminderPopupShown.value = false;
            try {
                await ElMessageBox.confirm(
                    `To apply for this job, you need to be logged in as Job seeker. If you already have an account, please log in. If you don't, please register first.`,
                    "Login Required to Apply",
                    {
                        confirmButtonText: "Register | Login",
                        cancelButtonText: "Cancel",
                        confirmButtonClass: "el-button--primary",
                        cancelButtonClass: "secondary",
                        showClose: false,
                    }
                );

                await (async () => {
                    try {

                        $router.push({
                            name: "auth",
                        });

                    } catch (error) {
                        ElMessage({
                            type: "error",
                            message: error.message,
                        });
                        console.log("error submit!!");
                    }
                })();
            } catch (error) {
                console.log(error);
            }

        };

   


        onMounted(() => {
            setPageClassGlobal('global_guset_job_listing_apply_page');
          
        });

        onBeforeMount(async () => {
            try {
                // Dispatch first action
                initialLoading.value = true
                if ($store.getters.isAuthenticated && userRole=='job-seeker') {
                    $router.push({
                        name: "job_seeker_application_details",
                        params: { jobId: jobId.value }
                    });
                }else{
                    const jobPostResponse = await $store.dispatch("JOB_LISTING_GUEST_JOB_DETAIL", {
                        jobId: jobId.value,
                        params: {
                            with: "pharmacy,pharmacy.settings,category,type",
                        },
                    });

                    job.value = jobPostResponse.data;
                    trackEvent('job_detail_viewed', { job_id: job.value.id, job_title: job.value.title, user_type: 'guest' });
                    console.log("all information",job?.value);
                    console.log("all information img",require('@/assets/img/us/toolbar-logo-us.png'));
                    console.log("all information url",window.location.href);
                    shareUrl.value = currentUrl + "job-listing/guest/job-details/" + job?.value?.id;
                    shareText.value = `${job.value.title}`;
                    useHead({
                        // title: job.value.title,
                        title: $filters.appName(),
                        meta: [
                        { name: 'description', content: job.value.shortDescription },
                        { property: 'og:title', content: job.value.title },
                        { property: 'og:description', content: job.value.shortDescription },
                        { property: 'og:image', content: require('@/assets/img/us/toolbar-logo-us.png') },
                        { property: 'og:url', content: `${window.location.href}` },
                        ],
                    });
                    initialLoading.value = false;
                }
               
                
          
                
            } catch (error) {
                const isJobNotAvailable =
                    error.response?.status === 410 ||
                    error.response?.data?.code === 410 ||
                    error.response?.data?.code === 'JOB_NOT_AVAILABLE' ||
                    error.code === 410 ||
                    error.code === 'JOB_NOT_AVAILABLE';
                if (isJobNotAvailable) {
                    initialLoading.value = false;
                    const message = error.response?.data?.message || (error.response?.status === 410 ? 'The job ad is not available anymore.' : error.message);
                    if (message) {
                        ElMessage.info(message);
                    }
                    $router.push({ name: 'job_seeker_index' });
                    return;
                }
                initialLoading.value = false;
                console.error("Error occurred:", error);
            }
        });

        const isShowMoreJD = computed(() => {
            const jobDescription = job.value.description || '';
            return jobDescription.split(' ').length > 50;
        });

        const displayedText = computed(() => {
            const original = job.value.description;
            if (state.isTruncated && original && original.split(' ').length > 50) {
                return original.split(' ').slice(0, 50).join(' ') + '...';
            } else {
                return original;
            }
        });

        const share = () => {

            const link = currentUrl + "job-listing/guest/job-details/" + job.value.id;
            const el = document.createElement("textarea");
            el.value = link;
            el.setAttribute("readonly", "");
            el.style.position = "absolute";
            el.style.left = "-9999px";
            document.body.appendChild(el);
            el.select();
            document.execCommand("copy");
            document.body.removeChild(el);
            ElMessageBox.alert("Link to current job copied to clipboard", "Thanks", {
                type: "success",
                showCancelButton: false,
                confirmButtonText: "Close",
                callback: () => {
                    console.log("btn click");
                },
            });
        };

        const toggleShareOptions = () => {
            showShareOptions.value = !showShareOptions.value
        }

        const shareLinks = computed(() => ({
            email: `mailto:?subject=${encodeURIComponent(shareText.value)}&body=${encodeURIComponent(shareUrl.value)}`,
            facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl.value)}`,
            twitter: `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText.value)}&url=${encodeURIComponent(shareUrl.value)}`,
            linkedin: `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(shareUrl.value)}&title=${encodeURIComponent(shareText.value)}`
        }))

        return {
            goBack,
            job,
            dialogVisible,
            showJobApplicationPopupMessage,
            reminderPopupShown,
            selectedOption,
            handleClose,
            handleConfirm,
            jobId,
            getClass,
            isJobApplied,
            handleJobPostApplySubmit,
            initialLoading,
            jobUnavailable,
            formData,
            displayedText,
            toggleView,
            state,
            share,
            userData,
            userRole,
            shareUrl,
            showShareOptions,
            toggleShareOptions,
            shareLinks,
            shareText,
            icons,
            isShowMoreJD,
        };
    },
};
</script>

<style scoped>
.job-detail-toolbar :deep(ion-buttons.toolbar-end-buttons) {
  right: 0;
  left: auto;
}

.mr-10 {
    margin-right: 10px;
}

.share-wrapper {
  position: relative;
}
.social-icons {
  position: absolute;
  top: 56px; /* adjust based on toolbar height */
  right: var(--locumate-side-spacing);
  background: white;
  border: 1px solid #ddd;
  padding: 2px;
  border-radius: 8px;
  display: flex;
  gap: 12px;
  z-index: 1000;
}
.social-icons a {
  font-size: 20px;
  color: #555;
  display: inline-block;
  padding: 6px;
  border-radius: 4px;
}
.social-icons a:hover {
  color: #000;
  background: rgb(var(--locumate-clr-bubble-selection));
}

.social-icons a {
  display: inline-flex;
  align-items: center;
}
.social-icons svg {
  width: 20px;
  height: 20px;
}
</style>
